import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as Icons from 'react-feather'
import InputEnter from '../generic/InputEnter'
import { getModel, updateModel } from '../data/Model'
import { getApiPath, requestAPI } from '../data/api'

class ImageUrlsBlacklist extends Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
			urlInput: '',
			urls: [],
			blacklistExistingCases: false,
			submitting: false,
		}
	}

	render() {
		const Model = getModel()
		const { blacklistExistingCases, submitting } = this.state
		return (
			<div id='image-url-blacklist' className='container'>
				<h1 style={{ marginTop: '30px', marginBottom: '20px' }}>
					Image Urls Blacklist
				</h1>
				<br />
				<div className='row'>
					<div className='col-md-5'>
						<InputEnter
							value={this.state.urlInput}
							disabled={submitting}
							onChange={(e) => {
								this.setState({
									urlInput: e.target.value,
								})
							}}
							onEnter={(url) => this.onAddUrl(url)}
							placeholder='Add url'
						/>
						<p>Existing, duplicate and invalid URLs will not be added.</p>
						<label
							style={{
								display: 'block',
								fontWeight: 'normal',
								marginTop: '10px',
							}}
						>
							<input
								type='checkbox'
								checked={blacklistExistingCases}
								disabled={submitting}
								onChange={(e) =>
									this.setState({ blacklistExistingCases: e.target.checked })
								}
								style={{ marginRight: '8px' }}
							/>
							Blacklist existing cases?
						</label>
						<p style={{ color: '#777' }}>
							Blacklisting on its own only prevents future results from entering
							the pipeline. Tick this to also whitelist the destination for
							every partner. This can take a while.
						</p>
						{submitting && (
							<p>
								<em>Blacklisting…</em>
							</p>
						)}
						<hr />
						<a
							download
							className='btn'
							style={{ float: 'left', marginTop: '40px' }}
							href={getApiPath(
								`/imageUrlBlacklist?type=text/csv&auth_token=${Model.auth_token}`,
							)}
						>
							Export
						</a>
					</div>
					<div className='col-md-7'>
						{sortUrls(getModel().image_url_blacklist.data).map((url) => (
							<ImageUrlBlacklistUrl key={url.id} url={url.url} />
						))}
						{getModel().image_url_blacklist.data.length === 0 &&
							getModel().image_url_blacklist.status.handle === 'loaded' && (
								<p>Image Blacklist is empty</p>
							)}
					</div>
				</div>
			</div>
		)
	}

	onAddUrl = async (url) => {
		if (this.state.submitting) return
		this.setState({ submitting: true })
		try {
			const response = await addBlacklistUrls(
				url,
				this.state.blacklistExistingCases,
			)
			await getBlacklist()
			this.setState({ urlInput: '' })
			alert(describeResult(response))
		} finally {
			this.setState({ submitting: false })
		}
	}

	componentDidMount = () => {
		if (this.props.client_ids.length > 0) {
			if (getModel().image_url_blacklist.status.handle === 'not-loaded')
				getBlacklist()
		}
	}
}

function describeResult(response) {
	if (!response || !response.message) return 'Something went wrong'
	const { message, existingCases } = response
	if (!existingCases) return message
	const failed =
		existingCases.failed > 0 ? `, ${existingCases.failed} failed` : ''
	return (
		`${message}\n\nExisting cases: whitelisted for ${existingCases.whitelisted} ` +
		`of ${existingCases.partners} partner(s), ${existingCases.alreadyWhitelisted} ` +
		`already whitelisted${failed}.`
	)
}

function sortUrls(urls) {
	return urls.slice().sort((a, b) => a.url.localeCompare(b.url))
}

class ImageUrlBlacklistUrl extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		return (
			<div className='imageBlacklistUrl'>
				<p>{this.props.url}</p>
				<span className='delete' onClick={this.onDeleteBlacklistUrl}>
					<Icons.Delete
						style={{
							height: '15px',
						}}
					/>
				</span>
			</div>
		)
	}

	onDeleteBlacklistUrl = async () => {
		const response = await deleteBlacklistUrl(this.props.url)
		getBlacklist()
		if (response.status === 200)
			return alert(`Successfully deleted ${this.props.url} from the blacklist`)
	}
}

async function getBlacklist() {
	await updateModel((model) => {
		model.image_url_blacklist.status.handle = 'loading'
		model.image_url_blacklist.data = []
		return model
	})
	return await requestAPI(`/imageUrlBlacklist`, 'GET').then((urls) => {
		updateModel((model) => {
			if (urls.length > 0) model.image_url_blacklist.data = urls
			model.image_url_blacklist.status.handle = 'loaded'
			model.image_url_blacklist.status.timestamp = new Date()
			return model
		})
	})
}

async function addBlacklistUrls(url, blacklistExistingCases) {
	const reqBody = {
		url: url,
		blacklistExistingCases: blacklistExistingCases === true,
	}
	return requestAPI('/imageUrlBlacklist', 'POST', reqBody)
}

async function deleteBlacklistUrl(url) {
	const reqBody = {
		url: url,
	}
	return requestAPI('/imageUrlBlacklist', 'DELETE', reqBody)
}

ImageUrlsBlacklist.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default ImageUrlsBlacklist
